var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{staticClass:"media-preview",style:({ backgroundImage: 'url(' + _vm.preview + ')' }),attrs:{"show":_vm.active,"close-modal-bottom":true,"footer-classes":"justify-content-start"},on:{"update:show":function($event){_vm.active=$event}}},[[_c('div',{staticClass:"col-12 text-center mt-0"},[_c('div',{ref:"preview"})])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }